"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContextQueue = (function () {
    function ContextQueue() {
        this._list = [];
        this.isActive = true;
    }
    ContextQueue.prototype.addContext = function (context) {
        if (this.isActive) {
            context.queueId = new Date().getTime();
            this._list.push(context);
        }
    };
    ContextQueue.prototype.clear = function () {
        this._list = [];
    };
    Object.defineProperty(ContextQueue.prototype, "isEmpty", {
        get: function () {
            return this._list.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextQueue.prototype, "lastContext", {
        get: function () {
            return _.last(this._list);
        },
        enumerable: true,
        configurable: true
    });
    ContextQueue.prototype.removeContextFromQueue = function (queueIdToDelete) {
        if (this._list.length < 1) {
            return;
        }
        var itemIndexToRemove = _.findIndex(this._list, function (item) { return item.queueId === queueIdToDelete; });
        if (itemIndexToRemove !== -1) {
            this._list.splice(itemIndexToRemove, 1);
        }
    };
    return ContextQueue;
}());
exports.ContextQueue = ContextQueue;
//# sourceMappingURL=contextQueue.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/posterControllerSupportingClasses/contextQueue.js
// module id = 60
// module chunks = 0